/* ==========================================================================
   INMURAL — Product Page JavaScript
   Gallery: thumbnail swap, arrow navigation
   Accordion: exclusive open on desktop, multi-select on mobile
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {

  /* ===== GALLERY KEYBOARD/THUMBNAILS REMOVED FOR ADER STYLE ===== */
  /* ===== GALLERY — MOBILE ===== */
  const mobileTrack = document.getElementById('inmural-mobile-track');
  const desktopGallery = document.getElementById('inmural-gallery-desktop');
  const galleryStack = document.getElementById('inmural-gallery-stack');
  const mobileArrows = document.querySelectorAll('.inmural-product__gallery-mobile-arrow');
  const mobileThumbs = document.querySelectorAll('.inmural-product__mobile-thumb');
  const mobileThumbStrip = document.querySelector('.inmural-product__mobile-thumbs');
  const mobilePlayBtn = document.querySelector('[data-carousel-play]');
  const desktopGalleryQuery = window.matchMedia('(min-width: 1024px)');
  let isProgrammaticScroll = false;
  let programmaticScrollTimer;

  function findThumb(mediaId) {
    if (!mobileThumbStrip) return null;
    return Array.from(mobileThumbs).find(function (thumb) {
      return String(thumb.getAttribute('data-media-id')) === String(mediaId);
    }) || null;
  }

  function setActiveMobileThumb(mediaId, targetThumb, skipReveal) {
    const target = targetThumb || findThumb(mediaId);
    if (!target) return;

    mobileThumbs.forEach(function (thumb) {
      thumb.classList.toggle('is-active', thumb === target);
    });
    if (!skipReveal) revealMobileThumb(target);
  }

  function scrollMobileToMedia(mediaId, behavior) {
    if (!mobileTrack) return;
    const realSlides = getMobileRealSlides();
    const index = realSlides.findIndex(function (slide) {
      return String(slide.getAttribute('data-media-id')) === String(mediaId);
    });
    if (index < 0) return;
    const offset = realSlides.length > 1 ? 1 : 0;
    isProgrammaticScroll = true;
    clearTimeout(programmaticScrollTimer);
    programmaticScrollTimer = window.setTimeout(function () {
      isProgrammaticScroll = false;
    }, 500);
    mobileTrack.scrollTo({
      left: (index + offset) * mobileTrack.offsetWidth,
      behavior: behavior || (window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth')
    });
  }

  function revealMobileThumb(thumb) {
    if (!mobileThumbStrip || !thumb) return;

    const stripRect = mobileThumbStrip.getBoundingClientRect();
    const thumbRect = thumb.getBoundingClientRect();
    const pad = 24;
    let left = mobileThumbStrip.scrollLeft;

    if (thumbRect.left < stripRect.left + pad) {
      left -= stripRect.left + pad - thumbRect.left;
    } else if (thumbRect.right > stripRect.right - pad) {
      left += thumbRect.right - (stripRect.right - pad);
    } else {
      return;
    }

    mobileThumbStrip.scrollTo({
      left: left,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  }

  function getMobileRealSlides() {
    if (!mobileTrack) return [];
    return Array.from(mobileTrack.querySelectorAll('.inmural-product__gallery-mobile-slide:not([data-clone="true"])'));
  }

  function rebuildMobileLoop(resetPosition) {
    if (!mobileTrack) return;

    mobileTrack.querySelectorAll('.inmural-product__gallery-mobile-slide[data-clone="true"]').forEach(function (slide) {
      slide.remove();
    });

    const realSlides = getMobileRealSlides();
    if (realSlides.length <= 1) {
      mobileTrack.scrollLeft = 0;
      return;
    }

    const firstClone = realSlides[0].cloneNode(true);
    const lastClone = realSlides[realSlides.length - 1].cloneNode(true);
    firstClone.setAttribute('data-clone', 'true');
    lastClone.setAttribute('data-clone', 'true');

    mobileTrack.insertBefore(lastClone, mobileTrack.firstChild);
    mobileTrack.appendChild(firstClone);

    if (resetPosition !== false) {
      requestAnimationFrame(function () {
        mobileTrack.scrollLeft = mobileTrack.offsetWidth;
      });
    }
  }

  function getMobileLoopIndex() {
    if (!mobileTrack) return 0;
    const slideWidth = mobileTrack.offsetWidth || 1;
    return Math.round(mobileTrack.scrollLeft / slideWidth);
  }

  /* ===== GALLERY AUTOPLAY =====
     The desktop carousel advances on its own until a colour is picked. The
     play button at the image's bottom right pauses and resumes it. */
  var autoplayTimer = null;
  var autoplayPausedByUser = false;
  var autoplayPausedForSelection = false;
  var autoplayDelay = 4000;
  var reduceGalleryMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function autoplayAllowed() {
    return !!mobileTrack && !!mobilePlayBtn && desktopGalleryQuery.matches &&
      !document.hidden && getMobileRealSlides().length > 1;
  }

  function syncAutoplayButton() {
    if (!mobilePlayBtn) return;
    var paused = autoplayPausedByUser || autoplayPausedForSelection;
    mobilePlayBtn.classList.toggle('is-paused', paused);
    mobilePlayBtn.setAttribute('aria-label', paused ? 'Play image autoplay' : 'Pause image autoplay');
  }

  function stopAutoplayTimer() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  }

  function advanceAutoplay() {
    if (!autoplayAllowed()) {
      stopAutoplayTimer();
      return;
    }

    var slideWidth = mobileTrack.offsetWidth;
    var slideCount = getMobileRealSlides().length;
    var activeIndex = getMobileLoopIndex();
    var nextIndex = activeIndex + 1;
    if (nextIndex > slideCount + 1) nextIndex = slideCount + 1;

    mobileTrack.scrollTo({
      left: nextIndex * slideWidth,
      behavior: reduceGalleryMotion.matches ? 'auto' : 'smooth'
    });
  }

  function startAutoplay() {
    stopAutoplayTimer();
    syncAutoplayButton();
    if (!autoplayAllowed() || autoplayPausedByUser || autoplayPausedForSelection) return;
    autoplayTimer = setInterval(advanceAutoplay, autoplayDelay);
  }

  function pauseAutoplayForSelection() {
    autoplayPausedForSelection = true;
    autoplayPausedByUser = false;
    stopAutoplayTimer();
    syncAutoplayButton();
  }

  function restartAutoplayAfterNavigation() {
    startAutoplay();
  }

  if (reduceGalleryMotion.matches) {
    autoplayPausedByUser = true;
  }

  if (mobilePlayBtn) {
    mobilePlayBtn.addEventListener('click', function () {
      var paused = autoplayPausedByUser || autoplayPausedForSelection;
      if (paused) {
        autoplayPausedByUser = false;
        autoplayPausedForSelection = false;
        startAutoplay();
      } else {
        autoplayPausedByUser = true;
        stopAutoplayTimer();
        syncAutoplayButton();
      }
    });
  }

  if (desktopGalleryQuery.addEventListener) {
    desktopGalleryQuery.addEventListener('change', function () {
      if (desktopGalleryQuery.matches) {
        startAutoplay();
      } else {
        stopAutoplayTimer();
      }
    });
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      stopAutoplayTimer();
    } else {
      startAutoplay();
    }
  });

  function moveVariantMediaToFront(mediaId) {
    if (!mediaId) return;

    if (galleryStack) {
      const desktopMedia = galleryStack.querySelector('[data-media-id="' + mediaId + '"]');
      if (desktopMedia && galleryStack.firstElementChild !== desktopMedia) {
        galleryStack.prepend(desktopMedia);
      }
      const desktopImage = desktopMedia ? desktopMedia.querySelector('img') : null;
      if (desktopImage) desktopImage.loading = 'eager';
    }

    if (mobileTrack) {
      mobileTrack.querySelectorAll('.inmural-product__gallery-mobile-slide[data-clone="true"]').forEach(function (slide) {
        slide.remove();
      });
      const mobileMedia = mobileTrack.querySelector('.inmural-product__gallery-mobile-slide[data-media-id="' + mediaId + '"]');
      if (mobileMedia && mobileTrack.firstElementChild !== mobileMedia) {
        mobileTrack.prepend(mobileMedia);
      }
      const mobileImage = mobileMedia ? mobileMedia.querySelector('img') : null;
      if (mobileImage) mobileImage.loading = 'eager';
      rebuildMobileLoop(true);
    }

    if (mobileThumbStrip) {
      const mobileThumb = mobileThumbStrip.querySelector('.inmural-product__mobile-thumb[data-media-id="' + mediaId + '"]');
      if (mobileThumb && mobileThumbStrip.firstElementChild !== mobileThumb) {
        mobileThumbStrip.prepend(mobileThumb);
      }
    }

    setActiveThumb(mediaId);
    setActiveMobileThumb(mediaId);
  }

  rebuildMobileLoop(true);
  startAutoplay();

  mobileArrows.forEach(function (arrow) {
    arrow.addEventListener('click', function () {
      if (!mobileTrack) return;
      const direction = this.getAttribute('data-direction');
      const slideWidth = mobileTrack.offsetWidth;
      const slideCount = getMobileRealSlides().length;
      const activeIndex = getMobileLoopIndex();
      let nextIndex = direction === 'next' ? activeIndex + 1 : activeIndex - 1;

      if (nextIndex > slideCount + 1) {
        nextIndex = slideCount + 1;
      } else if (nextIndex < 0) {
        nextIndex = 0;
      }

      mobileTrack.scrollTo({
        left: nextIndex * slideWidth,
        behavior: 'smooth'
      });
      restartAutoplayAfterNavigation();
    });
  });

  // Mobile thumbnail click scrolls to that slide
  if (mobileThumbStrip) {
    mobileThumbStrip.addEventListener('click', function (event) {
      const clicked = event.target.closest('.inmural-product__mobile-thumb');
      if (!clicked || !mobileThumbStrip.contains(clicked) || !mobileTrack) return;

      const mediaId = clicked.getAttribute('data-media-id');
      setActiveMobileThumb(mediaId, clicked, true);
      scrollMobileToMedia(mediaId);
      restartAutoplayAfterNavigation();
    });
  }

  // Desktop carousel dots: one per slide (the 3D model's is the "3D"
  // circle after the pill), matched to slides by data-index; the one for the
  // slide in view is filled, and a click scrolls to its slide
  const carouselDots = document.querySelectorAll('.inmural-product__carousel-dot');

  function setActiveDot(index) {
    carouselDots.forEach(function (dot) {
      dot.classList.toggle('is-active', Number(dot.getAttribute('data-index')) === index);
    });
  }

  carouselDots.forEach(function (dot) {
    const i = Number(dot.getAttribute('data-index'));
    dot.addEventListener('click', function () {
      if (!mobileTrack) return;
      const offset = getMobileRealSlides().length > 1 ? 1 : 0;
      mobileTrack.scrollTo({
        left: (i + offset) * mobileTrack.offsetWidth,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
      setActiveDot(i);
      restartAutoplayAfterNavigation();
    });
  });

  // Update mobile thumb active state as the main image moves. Only the slide
  // loop reset waits for the swipe to settle.
  if (mobileTrack) {
    let scrollTimeout;

    function normalizeMobileLoop() {
      const slideWidth = mobileTrack.offsetWidth;
      const slideCount = getMobileRealSlides().length;
      if (slideCount <= 1) return;

      const activeIndex = Math.round(mobileTrack.scrollLeft / slideWidth);
      if (activeIndex === 0) {
        mobileTrack.scrollLeft = slideCount * slideWidth;
      } else if (activeIndex === slideCount + 1) {
        mobileTrack.scrollLeft = slideWidth;
      }
    }

    mobileTrack.addEventListener('scroll', function () {
      if (isProgrammaticScroll) return;

      const slideWidth = mobileTrack.offsetWidth;
      const realSlides = getMobileRealSlides();
      const slideCount = realSlides.length;
      let activeIndex = Math.round(mobileTrack.scrollLeft / slideWidth);

      if (slideCount > 1) {
        if (activeIndex === 0) {
          activeIndex = slideCount;
        } else if (activeIndex === slideCount + 1) {
          activeIndex = 1;
        }
      }

      const activeSlide = realSlides[slideCount > 1 ? activeIndex - 1 : 0];
      if (activeSlide) {
        const mediaId = activeSlide.getAttribute('data-media-id');
        const activeThumb = mobileThumbStrip ? mobileThumbStrip.querySelector('.inmural-product__mobile-thumb.is-active') : null;
        if (!activeThumb || String(activeThumb.getAttribute('data-media-id')) !== String(mediaId)) {
          setActiveMobileThumb(mediaId);
        }
      }
      setActiveDot(slideCount > 1 ? activeIndex - 1 : 0);

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(normalizeMobileLoop, 100);
    });

    window.addEventListener('resize', function () {
      rebuildMobileLoop(false);
      const activeThumb = mobileThumbStrip ? mobileThumbStrip.querySelector('.inmural-product__mobile-thumb.is-active') : null;
      if (activeThumb) {
        revealMobileThumb(activeThumb);
      }
    });
  }


  /* ===== GALLERY — DESKTOP THUMBNAILS ===== */
  const galleryThumbs = document.querySelectorAll('.inmural-product__thumb');

  function setActiveThumb(mediaId) {
    galleryThumbs.forEach(function (thumb) {
      thumb.classList.toggle('is-active', String(thumb.getAttribute('data-media-id')) === String(mediaId));
    });
  }

  function updateActiveThumbFromScroll() {
    if (!galleryStack) return;
    const stackImages = galleryStack.querySelectorAll('.inmural-product__main-image');
    if (!stackImages.length || !galleryThumbs.length) return;

    const threshold = getHeaderOffset() + 80;
    let activeId = stackImages[0].getAttribute('data-media-id');

    stackImages.forEach(function (image) {
      if (image.getBoundingClientRect().top <= threshold) {
        activeId = image.getAttribute('data-media-id');
      }
    });

    setActiveThumb(activeId);
  }

  galleryThumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!galleryStack) return;

      const mediaId = this.getAttribute('data-media-id');
      const target = galleryStack.querySelector('.inmural-product__main-image[data-media-id="' + mediaId + '"]');
      if (!target) return;

      const top = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - 16;
      window.scrollTo({
        top: top,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
      setActiveThumb(mediaId);
    });
  });

  if (galleryThumbs.length && galleryStack) {
    updateActiveThumbFromScroll();
    window.addEventListener('scroll', updateActiveThumbFromScroll, { passive: true });
  }


  /* ===== ACCORDIONS ===== */
  const accordionContainers = document.querySelectorAll('.inmural-accordions');

  accordionContainers.forEach(function (accordionContainer) {
    const accordions = accordionContainer.querySelectorAll('.inmural-accordion');
    const triggers = accordionContainer.querySelectorAll('[data-accordion-trigger]');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        const accordion = this.closest('.inmural-accordion');
        const isOpen = accordion.classList.contains('is-open');
        const isDesktop = window.innerWidth >= 1024;
        // The product page's spec dropdowns start open and open or close
        // one at a time on their own; other accordions stay one-open on desktop
        const isSpecs = accordionContainer.classList.contains('inmural-product__spec-accordions');

        if (isDesktop && !isSpecs) {
          accordions.forEach(function (acc) {
            if (acc !== accordion) {
              closeAccordion(acc);
            }
          });
        }

        if (isOpen) {
          closeAccordion(accordion);
        } else {
          openAccordion(accordion);
        }
      });
    });
  });

  function openAccordion(accordion) {
    const body = accordion.querySelector('[data-accordion-body]');
    const icon = accordion.querySelector('[data-accordion-icon]');
    const trigger = accordion.querySelector('[data-accordion-trigger]');

    accordion.classList.add('is-open');
    if (icon) icon.textContent = '−';
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    if (body) {
      body.style.maxHeight = body.scrollHeight + 'px';
    }
  }

  function closeAccordion(accordion) {
    const body = accordion.querySelector('[data-accordion-body]');
    const icon = accordion.querySelector('[data-accordion-icon]');
    const trigger = accordion.querySelector('[data-accordion-trigger]');

    accordion.classList.add('inmural-accordion--closing');
    if (icon) icon.textContent = '+';
    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    if (body) {
      body.style.maxHeight = '0';
    }

    setTimeout(function () {
      accordion.classList.remove('is-open');
      accordion.classList.remove('inmural-accordion--closing');
    }, 200);
  }

  document.querySelectorAll('.inmural-product__spec-accordions .inmural-accordion').forEach(function (accordion) {
    openAccordion(accordion);
  });


  /* ===== VARIANT SELECTOR ===== */
  const variantBtns = document.querySelectorAll('.inmural-product__variant-btn');
  const variantIdInput = document.getElementById('inmural-variant-id');
  const addToCartForm = document.getElementById('inmural-product-form');
  const priceEl = document.getElementById('inmural-price');
  const stockStatusEl = document.getElementById('inmural-stock-status');
  const stockStatusDot = stockStatusEl ? stockStatusEl.querySelector('.inmural-product__stock-dot') : null;
  const stockStatusText = stockStatusEl ? stockStatusEl.querySelector('.inmural-product__stock-status-text') : null;
  const productErrorWrapper = document.getElementById('inmural-product-error');
  const productErrorMessage = productErrorWrapper ? productErrorWrapper.querySelector('.product-form__error-message') : null;
  const addToCartBtn = document.querySelector('.inmural-product__add-to-cart .inmural-btn-filled');
  const addToCartSpinner = null; // loading dots are shown by CSS from the button's .loading class
  const variants = window.product_variants || [];
  const optionGroups = Array.prototype.slice.call(document.querySelectorAll('[data-option-group]')).sort(function (a, b) {
    return Number(a.getAttribute('data-option-position')) - Number(b.getAttribute('data-option-position'));
  });
  let addRequestController = null;
  let stickyAddedTimer = null;
  let productSuccessTimeout = null;
  let stockStatusTimeout = null;

  /* ===== QUANTITY ===== */
  const quantityInput = document.getElementById('inmural-quantity');
  const quantityMinus = document.querySelector('[data-quantity-minus]');
  const quantityPlus = document.querySelector('[data-quantity-plus]');
  const stickyQuantityInput = document.getElementById('inmural-sticky-quantity');
  const stickyQuantityMinus = document.querySelector('[data-sticky-quantity-minus]');
  const stickyQuantityPlus = document.querySelector('[data-sticky-quantity-plus]');

  function setQuantity(value) {
    if (!quantityInput) return;
    var min = parseInt(quantityInput.min, 10) || 1;
    var max = parseInt(quantityInput.max, 10) || Infinity;
    var next = Math.max(min, Math.min(max, value));
    quantityInput.value = next;
    if (stickyQuantityInput) stickyQuantityInput.value = next;
    if (quantityMinus) quantityMinus.disabled = next <= min;
    if (quantityPlus) quantityPlus.disabled = next >= max;
    if (stickyQuantityMinus) stickyQuantityMinus.disabled = next <= min;
    if (stickyQuantityPlus) stickyQuantityPlus.disabled = next >= max;
  }

  if (quantityInput) {
    if (quantityMinus) {
      quantityMinus.addEventListener('click', function () {
        setQuantity((parseInt(quantityInput.value, 10) || 1) - 1);
      });
    }
    if (quantityPlus) {
      quantityPlus.addEventListener('click', function () {
        setQuantity((parseInt(quantityInput.value, 10) || 1) + 1);
      });
    }
    quantityInput.addEventListener('change', function () {
      setQuantity(parseInt(quantityInput.value, 10) || 1);
    });
    if (stickyQuantityMinus) {
      stickyQuantityMinus.addEventListener('click', function () {
        setQuantity((parseInt(quantityInput.value, 10) || 1) - 1);
      });
    }
    if (stickyQuantityPlus) {
      stickyQuantityPlus.addEventListener('click', function () {
        setQuantity((parseInt(quantityInput.value, 10) || 1) + 1);
      });
    }
    if (stickyQuantityInput) {
      stickyQuantityInput.addEventListener('change', function () {
        setQuantity(parseInt(stickyQuantityInput.value, 10) || 1);
      });
    }
    setQuantity(parseInt(quantityInput.value, 10) || 1);
  }

  function getHeaderOffset() {
    var rootStyles = getComputedStyle(document.documentElement);
    var headerHeightValue = parseFloat(rootStyles.getPropertyValue('--header-height')) || 60;
    var productBar = document.getElementById('inmural-product-bar');
    var barHeight = productBar ? productBar.getBoundingClientRect().height : 0;
    return barHeight > headerHeightValue ? barHeight : headerHeightValue;
  }

  function scrollToFirstVariant() {
    var firstGroup = optionGroups[0];
    if (!firstGroup) return;

    var targetTop = Math.max(0, firstGroup.getBoundingClientRect().top + window.scrollY - getHeaderOffset());
    window.scrollTo({
      top: targetTop,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  }

  function setProductError(message) {
    if (!productErrorWrapper || !productErrorMessage) return;

    if (message) {
      setProductSuccess('');
      productErrorMessage.textContent = message;
      productErrorWrapper.hidden = false;
    } else {
      productErrorMessage.textContent = '';
      productErrorWrapper.hidden = true;
    }
  }

  function setProductSuccess(message) {
    if (!addToCartBtn) return;

    if (productSuccessTimeout) {
      clearTimeout(productSuccessTimeout);
      productSuccessTimeout = null;
    }

    if (message) {
      addToCartBtn.classList.add('is-success');
      productSuccessTimeout = setTimeout(function () {
        addToCartBtn.classList.remove('is-success');
        productSuccessTimeout = null;
      }, 2500);
    } else {
      addToCartBtn.classList.remove('is-success');
    }
  }

  function renderStockStatus(stockState) {
    if (!stockStatusText) return;

    stockStatusEl.classList.remove('is-temporary-message');
    if (stockStatusDot) {
      stockStatusDot.classList.remove(
        'inmural-product__stock-dot--warning',
        'inmural-product__stock-dot--in-stock',
        'inmural-product__stock-dot--low-stock',
        'inmural-product__stock-dot--sold-out'
      );
      stockStatusDot.classList.add('inmural-product__stock-dot--' + stockState.dotState);
      stockStatusDot.hidden = false;
    }
    stockStatusText.textContent = stockState.label;
  }

  function clearTemporaryStockStatus() {
    if (stockStatusTimeout) {
      clearTimeout(stockStatusTimeout);
      stockStatusTimeout = null;
    }
    if (stockStatusEl) {
      stockStatusEl.classList.remove('is-temporary-message');
    }
  }

  function setTemporaryStockStatus(message, variant) {
    if (!stockStatusText || !stockStatusEl) return;

    clearTemporaryStockStatus();
    stockStatusEl.classList.add('is-temporary-message');
    stockStatusText.textContent = message;

    if (stockStatusDot) {
      stockStatusDot.hidden = false;
      stockStatusDot.classList.remove(
        'inmural-product__stock-dot--in-stock',
        'inmural-product__stock-dot--low-stock',
        'inmural-product__stock-dot--sold-out'
      );
      stockStatusDot.classList.add('inmural-product__stock-dot--sold-out');
    }

    stockStatusTimeout = setTimeout(function () {
      renderStockStatus(getStockState(variant));
      stockStatusTimeout = null;
    }, 2800);
  }

  // Stock left for this variant once what's already in the cart is counted.
  // Untracked stock (or stock that can oversell) never runs out here.
  function isTracked(variant) {
    return !!(variant && variant.inventory_management && variant.inventory_policy === 'deny' &&
      typeof variant.inventory_quantity === 'number');
  }

  function remainingStock(variant) {
    if (!isTracked(variant)) return Infinity;
    return variant.inventory_quantity - (variant.cart_quantity || 0);
  }

  function canAddToCart(variant) {
    return !!(variant && variant.available && remainingStock(variant) > 0);
  }

  function getStockState(variant) {
    if (!canAddToCart(variant)) {
      return {
        label: 'Out of stock',
        dotState: 'sold-out'
      };
    }

    var remaining = remainingStock(variant);
    if (remaining < 10) {
      return {
        label: 'Only ' + remaining + ' in stock',
        dotState: 'low-stock'
      };
    }

    return {
      label: 'In stock',
      dotState: 'in-stock'
    };
  }

  // Stock pill + button for a variant: disabled once nothing more can be added
  function renderBuyState(variant) {
    renderStockStatus(getStockState(variant));
    if (!addToCartBtn) return;
    var canAdd = canAddToCart(variant);
    addToCartBtn.classList.toggle('is-disabled', !canAdd);
    var label = addToCartBtn.querySelector('.inmural-product__add-to-cart-label');
    if (label) label.textContent = canAdd ? 'Add to cart' : 'Out of stock';
    if (canAdd) {
      addToCartBtn.removeAttribute('aria-disabled');
    } else {
      addToCartBtn.setAttribute('aria-disabled', 'true');
    }
  }

  function currentVariant() {
    var id = variantIdInput ? variantIdInput.value : null;
    return variants.find(function (variant) {
      return String(variant.id) === String(id);
    });
  }

  // Re-read the cart (e.g. after items are removed in the cart drawer)
  async function refreshCartQuantities() {
    try {
      const response = await fetch(window.routes.cart_url + '.js', {
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      const cart = await response.json();
      variants.forEach(function (variant) { variant.cart_quantity = 0; });
      (cart.items || []).forEach(function (item) {
        var variant = variants.find(function (v) { return String(v.id) === String(item.id); });
        if (variant) variant.cart_quantity += item.quantity;
      });
      var variant = currentVariant();
      if (variant) renderBuyState(variant);
    } catch (error) {
      console.error(error);
    }
  }

  function getAvailabilityWarning(variant) {
    if (!variant || !variant.inventory_management || variant.inventory_policy !== 'deny') {
      return null;
    }

    if (typeof variant.inventory_quantity !== 'number' || variant.inventory_quantity < 0) {
      return null;
    }

    const quantityLabel = variant.inventory_quantity === 1 ? 'item was' : 'items were';
    return 'Only ' + variant.inventory_quantity + ' ' + quantityLabel + ' added to your cart due to availability.';
  }

  async function getCartVariantQuantity(variantId) {
    const response = await fetch(window.routes.cart_url + '.js', {
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    const cart = await response.json();
    let quantityInCart = 0;

    if (cart && Array.isArray(cart.items)) {
      cart.items.forEach(function (item) {
        if (String(item.id) === String(variantId)) {
          quantityInCart += item.quantity;
        }
      });
    }

    return quantityInCart;
  }

  function setAddToCartLoading(isLoading) {
    if (!addToCartBtn) return;

    addToCartBtn.classList.toggle('loading', isLoading);
    if (isLoading) {
      addToCartBtn.setAttribute('aria-disabled', 'true');
    } else if (canAddToCart(currentVariant())) {
      addToCartBtn.removeAttribute('aria-disabled');
    } else {
      // stays disabled if that was the last one
      addToCartBtn.setAttribute('aria-disabled', 'true');
    }
    if (addToCartSpinner) {
      addToCartSpinner.classList.toggle('hidden', !isLoading);
    }
  }

  function swapStickyContent(added) {
    if (!stickyBar) return;
    stickyBar.classList.add('is-swapping');
    setTimeout(function () {
      stickyBar.classList.toggle('is-added', added);
      window.requestAnimationFrame(function () {
        stickyBar.classList.remove('is-swapping');
      });
    }, 160);
  }

  function showStickyAdded(src) {
    if (!stickyBar) return;
    var image = stickyBar.querySelector('[data-sticky-added-image]');
    if (image) {
      image.hidden = !src;
      if (src) image.src = src;
    }
    swapStickyContent(true);
    clearTimeout(stickyAddedTimer);
    stickyAddedTimer = setTimeout(function () {
      swapStickyContent(false);
    }, 3500);
  }

  async function submitAddToCart(event) {
    event.preventDefault();

    if (!addToCartForm || !addToCartBtn || addToCartBtn.disabled || addToCartBtn.getAttribute('aria-disabled') === 'true') {
      return;
    }

    if (addRequestController) {
      addRequestController.abort();
    }

    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const formData = new FormData(addToCartForm);
    const selectedVariantId = formData.get('id');
    const selectedVariant = variants.find(function (variant) {
      return String(variant.id) === String(selectedVariantId);
    });

    setProductError('');
    setProductSuccess('');
    clearTemporaryStockStatus();

    if (selectedVariant && selectedVariant.inventory_management && selectedVariant.inventory_policy === 'deny') {
      try {
        const quantityInCart = await getCartVariantQuantity(selectedVariant.id);
        if (quantityInCart >= selectedVariant.inventory_quantity) {
          setTemporaryStockStatus(getAvailabilityWarning(selectedVariant), selectedVariant);
          return;
        }
      } catch (error) {
        console.error(error);
      }
    }

    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      formData.append('sections_url', window.location.pathname);

      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    }

    addRequestController = new AbortController();
    setAddToCartLoading(true);

    try {
      const response = await fetch(routes.cart_add_url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData,
        signal: addRequestController.signal
      });
      const payload = await response.json();

      if (payload.status) {
        setProductError(payload.description || payload.errors || payload.message);
        return;
      }

      setProductError('');
      setProductSuccess('Added to cart');

      // The desktop product bar plays its added animation when it is showing
      document.dispatchEvent(new CustomEvent('inmural:product-added', { detail: { variant: selectedVariant } }));
      var addedImage = document.querySelector('.inmural-product__main-image img');
      var addedImageSrc = (selectedVariant && selectedVariant.image) || (addedImage && (addedImage.currentSrc || addedImage.src)) || '';
      if (mobileQuery.matches && stickyBar && stickyBar.classList.contains('is-visible')) {
        showStickyAdded(addedImageSrc);
      } else if (window.inmuralShowAddedToast) {
        window.inmuralShowAddedToast(addedImageSrc);
      }

      // Count what was just added; if it was the last one, switch to out of stock
      if (selectedVariant) {
        selectedVariant.cart_quantity = (selectedVariant.cart_quantity || 0) + (Number(formData.get('quantity')) || 1);
        renderBuyState(selectedVariant);
      }

      if (cart && typeof cart.renderContents === 'function') {
        cart.renderContents(payload);
        const drawerEl = document.querySelector('cart-drawer');
        if (drawerEl) {
          drawerEl.classList.toggle('is-empty', payload.item_count === 0);
        }
      } else {
        window.location = window.routes.cart_url;
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error(error);
      }
    } finally {
      setAddToCartLoading(false);
      addRequestController = null;
    }
  }

  function getGroupPosition(group) {
    return Number(group.getAttribute('data-option-position'));
  }

  function getGroupValue(group) {
    if (group.classList.contains('inmural-product__color')) {
      var valueEl = group.querySelector('.inmural-product__color-value');
      return valueEl ? valueEl.getAttribute('data-option-value') : null;
    }
    var selected = group.querySelector('.inmural-product__variant-btn.is-selected');
    return selected ? selected.getAttribute('data-option-value') : null;
  }

  function setGroupValue(group, value) {
    if (group.classList.contains('inmural-product__color')) {
      var valueEl = group.querySelector('.inmural-product__color-value');
      if (valueEl) valueEl.setAttribute('data-option-value', value);

      var label = group.querySelector('[data-color-label]');
      if (label) label.textContent = value;

      group.querySelectorAll('.inmural-product__swatch, .inmural-product__color-option').forEach(function (swatch) {
        var selected = swatch.getAttribute('data-option-value') === value;
        swatch.classList.toggle('is-selected', selected);
        swatch.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
      return;
    }

    group.querySelectorAll('.inmural-product__variant-btn').forEach(function (button) {
      var selected = button.getAttribute('data-option-value') === value;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-checked', selected ? 'true' : 'false');
    });
  }

  function collectSelectedMap() {
    var byPosition = {};

    optionGroups.forEach(function (group) {
      var position = getGroupPosition(group);
      var value = getGroupValue(group);
      if (position && value !== null) byPosition[position] = value;
    });

    return byPosition;
  }

  function collectSelectedOptions() {
    var byPosition = collectSelectedMap();

    return Object.keys(byPosition)
      .map(Number)
      .sort(function (a, b) { return a - b; })
      .map(function (position) { return byPosition[position]; });
  }

  function matchesParents(variant, position, selectedMap) {
    for (var i = 0; i < variant.options.length; i++) {
      var optionPosition = i + 1;
      if (optionPosition >= position) break;
      if (variant.options[i] !== selectedMap[optionPosition]) return false;
    }
    return true;
  }

  function valueAvailable(group, value, selectedMap) {
    var position = getGroupPosition(group);

    return variants.some(function (variant) {
      return variant.options[position - 1] === value && matchesParents(variant, position, selectedMap);
    });
  }

  function firstAvailableValue(group, selectedMap) {
    var values = [];

    group.querySelectorAll('button[data-option-value]').forEach(function (button) {
      var value = button.getAttribute('data-option-value');
      if (values.indexOf(value) === -1) values.push(value);
    });

    for (var i = 0; i < values.length; i++) {
      if (valueAvailable(group, values[i], selectedMap)) return values[i];
    }

    return values[0];
  }

  function refreshDependentOptions(fromPosition) {
    var selectedMap = collectSelectedMap();

    optionGroups.forEach(function (group) {
      var position = getGroupPosition(group);
      if (position < fromPosition) return;

      var currentValue = getGroupValue(group);
      if (position > 1 && currentValue && !valueAvailable(group, currentValue, selectedMap)) {
        var nextValue = firstAvailableValue(group, selectedMap);
        if (nextValue !== undefined) {
          setGroupValue(group, nextValue);
          selectedMap[position] = nextValue;
        }
      }

      if (position === 1) return;

      group.querySelectorAll('button[data-option-value]').forEach(function (button) {
        var value = button.getAttribute('data-option-value');
        var available = valueAvailable(group, value, selectedMap);
        button.disabled = !available;
        button.classList.toggle('is-unavailable', !available);
        button.setAttribute('aria-disabled', available ? 'false' : 'true');
      });
    });
  }

  function applyVariant() {
    var selectedOptions = collectSelectedOptions();
    var matchedVariant = null;

    for (var i = 0; i < variants.length; i++) {
      var candidate = variants[i];
      var match = true;
      for (var j = 0; j < candidate.options.length; j++) {
        if (candidate.options[j] !== selectedOptions[j]) {
          match = false;
          break;
        }
      }
      if (match) {
        matchedVariant = candidate;
        break;
      }
    }

    if (!matchedVariant) return;

    setProductError('');
    setProductSuccess('');
    clearTemporaryStockStatus();
    scrollToFirstVariant();
    if (variantIdInput) variantIdInput.value = matchedVariant.id;
    var saleBadge = document.getElementById('inmural-sale-badge');
    var onSale = !!(matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price);
    if (saleBadge) saleBadge.hidden = !onSale;
    var percentOff = document.getElementById('inmural-percent-off');
    if (percentOff) {
      percentOff.hidden = !onSale;
      if (onSale) {
        percentOff.textContent = Math.round((matchedVariant.compare_at_price - matchedVariant.price) * 100 / matchedVariant.compare_at_price) + '% Off';
      }
    }
    if (priceEl) {
      if (onSale) {
        priceEl.innerHTML = '<s class="inmural-product__compare-price">' + matchedVariant.compare_at_price_formatted + '</s> <span class="inmural-product__regular-price">' + matchedVariant.price_formatted + '</span>';
      } else {
        priceEl.innerHTML = '<span class="inmural-product__regular-price">' + matchedVariant.price_formatted + '</span>';
      }
    }
    renderBuyState(matchedVariant);
    if (window.inmuralUpdateProductBar) window.inmuralUpdateProductBar(matchedVariant, canAddToCart(matchedVariant));

    var url = new URL(window.location.href);
    url.searchParams.set('variant', matchedVariant.id);
    window.history.replaceState({}, '', url.toString());

    moveVariantMediaToFront(matchedVariant.featured_media_id);
  }

  variantBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = this.closest('[data-option-group]');
      if (!group) return;
      setGroupValue(group, this.getAttribute('data-option-value'));
      refreshDependentOptions(getGroupPosition(group));
      applyVariant();
    });
  });

  /* ===== COLOUR SWATCHES ===== */
  var colorHexMap = {
    black: '#000000',
    white: '#ffffff',
    grey: '#8c8c8c',
    gray: '#8c8c8c',
    silver: '#c0c0c0',
    beige: '#e8e0d0',
    cream: '#f5f0e1',
    brown: '#8b5a2b',
    tan: '#d2b48c',
    navy: '#1e3a5f',
    blue: '#2563eb',
    green: '#16a34a',
    red: '#e02424',
    pink: '#ec4899'
  };

  function colorHex(name) {
    return colorHexMap[String(name).trim().toLowerCase()] || '#cccccc';
  }

  function colorParts(name) {
    return String(name).split('/').map(function (part) {
      return part.trim().toLowerCase();
    }).filter(Boolean);
  }

  function colorBackground(name) {
    var parts = colorParts(name);

    if (parts.length === 2) {
      var first = colorHexMap[parts[0]] || parts[0];
      var second = colorHexMap[parts[1]] || parts[1];
      return 'linear-gradient(135deg, ' + first + ' 50%, ' + second + ' 50%)';
    }

    return colorHex(name);
  }

  document.querySelectorAll('.inmural-product__color').forEach(function (container) {
    var valueEl = container.querySelector('.inmural-product__color-value');
    // Desktop round swatches and mobile text buttons pick the same value
    var swatches = container.querySelectorAll('.inmural-product__swatch, .inmural-product__color-option');

    if (!valueEl) return;

    // Split names such as White/Silver override the single Shopify swatch
    container.querySelectorAll('.inmural-product__color-dot').forEach(function (dot) {
      var option = dot.closest('[data-option-value]');
      if (!option) return;
      var name = option.getAttribute('data-option-value');
      if (colorParts(name).length === 2 || !dot.hasAttribute('data-swatch-set')) {
        dot.style.background = colorBackground(name);
      }
    });

    swatches.forEach(function (swatch) {
      if (swatch.classList.contains('inmural-product__swatch')) {
        var name = swatch.getAttribute('data-option-value');
        if (colorParts(name).length === 2 || !swatch.hasAttribute('data-swatch-set')) {
          swatch.style.background = colorBackground(name);
        }
      }

      swatch.addEventListener('click', function () {
        var group = swatch.closest('[data-option-group]');
        if (!group) return;

        var value = swatch.getAttribute('data-option-value');
        pauseAutoplayForSelection();
        if (getGroupValue(group) === value) return;

        setGroupValue(group, value);
        refreshDependentOptions(getGroupPosition(group));
        applyVariant();
      });
    });
  });

  refreshDependentOptions(2);

  if (addToCartForm) {
    addToCartForm.addEventListener('submit', submitAddToCart);
  }

  /* ===== STICKY ADD TO BAG (Figma 309:27) =====
     Phones and tablets: the page's own Add to cart block is hidden, and this
     bar carries the controls. It scales in and unblurs as soon as the page
     scrolls and stays until the footer enters, submitting the same hidden
     form. */
  var stickyBar = document.getElementById('inmural-sticky-bar');
  var stickyBtn = stickyBar ? stickyBar.querySelector('.inmural-product__sticky-btn') : null;
  var mobileQuery = window.matchMedia('(max-width: 1023px)');

  if (stickyBar && stickyBtn && addToCartBtn && addToCartForm) {
    var stickyFrame = null;
    var reduceStickyMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Read on every scroll so the bar can drop as soon as the footer appears
    function renderStickyBar() {
      stickyFrame = null;
      // The footer sits behind the page; it is showing once the main
      // content's bottom edge rises above the bottom of the screen
      var main = document.getElementById('MainContent');
      var inFooter = main ? main.getBoundingClientRect().bottom < window.innerHeight : false;
      var show = mobileQuery.matches && window.scrollY > 0 && !inFooter;
      var wasShown = stickyBar.classList.contains('is-visible') && !stickyBar.classList.contains('is-leaving');
      if (show) {
        stickyBar.classList.remove('is-leaving');
        stickyBar.classList.add('is-visible');
      } else if (wasShown && !reduceStickyMotion.matches) {
        // slide down, then drop out of the page
        stickyBar.classList.add('is-leaving');
      } else if (!stickyBar.classList.contains('is-leaving')) {
        stickyBar.classList.remove('is-visible', 'is-added', 'is-swapping');
      }
      // Root background black while the bar shows, so the overscroll area
      // and Safari's bottom toolbar strip under the bar read as black too
      document.documentElement.classList.toggle('inmural-sticky-bar-open', show);
      stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      stickyBar.querySelectorAll('button, input').forEach(function (el) {
        el.tabIndex = show ? 0 : -1;
      });
    }

    function syncStickyState() {
      var disabled = addToCartBtn.classList.contains('is-disabled');
      var label = addToCartBtn.querySelector('.inmural-product__add-to-cart-label');
      stickyBtn.disabled = disabled || addToCartBtn.classList.contains('loading');
      stickyBtn.textContent = disabled ? (label ? label.textContent : 'Out of stock') : 'Add to cart';
    }

    stickyBar.addEventListener('animationend', function () {
      if (stickyBar.classList.contains('is-leaving')) {
        stickyBar.classList.remove('is-leaving', 'is-visible');
      }
    });

    function queueStickyBar() {
      if (stickyFrame === null) stickyFrame = requestAnimationFrame(renderStickyBar);
    }

    window.addEventListener('scroll', queueStickyBar, { passive: true });
    window.addEventListener('resize', queueStickyBar);
    renderStickyBar();

    new MutationObserver(syncStickyState).observe(addToCartBtn, { attributes: true, attributeFilter: ['class'] });
    syncStickyState();

    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', renderStickyBar);

    var stickyViewCart = stickyBar.querySelector('[data-sticky-view-cart]');
    if (stickyViewCart) {
      stickyViewCart.addEventListener('click', function () {
        swapStickyContent(false);
        var cartButton = document.getElementById('cart-icon-bubble');
        if (cartButton) cartButton.click();
      });
    }

    stickyBtn.addEventListener('click', function () {
      if (stickyBtn.disabled) return;
      if (addToCartForm.requestSubmit) addToCartForm.requestSubmit(addToCartBtn);
      else addToCartBtn.click();
    });
  }

  /* ===== SAVE + SHARE (Figma 311:100) =====
     Save is remembered in this browser only; share uses the system share
     sheet, or copies the link where there is none. */
  var saveButton = document.querySelector('[data-product-save]');
  var shareButton = document.querySelector('[data-product-share]');
  var saveKey = 'inmural-saved:' + window.location.pathname;

  function renderSaved(saved) {
    if (!saveButton) return;
    saveButton.setAttribute('aria-pressed', saved ? 'true' : 'false');
    saveButton.setAttribute('aria-label', saved ? 'Saved' : 'Save');
  }

  if (saveButton) {
    try { renderSaved(window.localStorage.getItem(saveKey) === '1'); } catch (e) {}
    saveButton.addEventListener('click', function () {
      var saved = saveButton.getAttribute('aria-pressed') !== 'true';
      renderSaved(saved);
      try {
        if (saved) window.localStorage.setItem(saveKey, '1');
        else window.localStorage.removeItem(saveKey);
      } catch (e) {}
    });
  }

  if (shareButton) {
    shareButton.addEventListener('click', function () {
      var url = window.location.href;
      if (navigator.share) {
        navigator.share({ title: window.inmural_product_title || document.title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          shareButton.setAttribute('aria-label', 'Link copied');
          setTimeout(function () { shareButton.setAttribute('aria-label', 'Share'); }, 2000);
        }).catch(function () {});
      }
    });
  }

  // Keep stock in step with the cart drawer (removing items frees stock up)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'product-form') return;
      refreshCartQuantities();
    });
  }



  // The sticky first image lasts as long as the information card
  var stickyMain = document.querySelector('.inmural-product__sticky-main');
  var infoCard = document.querySelector('.inmural-product__info-card');

  function sizeStickyMain() {
    if (!stickyMain) return;
    if (!window.matchMedia('(min-width: 1024px)').matches) {
      stickyMain.style.height = '';
      return;
    }
    var image = stickyMain.querySelector('.inmural-product__main-image');
    var cardHeight = infoCard ? infoCard.getBoundingClientRect().height : 0;
    var imageHeight = image ? image.getBoundingClientRect().height : 0;
    stickyMain.style.height = Math.max(cardHeight, imageHeight) + 'px';
  }

  if (stickyMain) {
    sizeStickyMain();
    window.addEventListener('resize', sizeStickyMain);
    window.addEventListener('load', sizeStickyMain);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sizeStickyMain);
    if ('ResizeObserver' in window && infoCard) new ResizeObserver(sizeStickyMain).observe(infoCard);
  }

});
